<script>
export default {
    methods: {
        calculateDriverStatus(status) {
            switch (status) {
                case 'DELETED':
                    return {
                        label: status,
                        type: 'DANGER'
                    }
                case 'ACTIVE':
                    return {
                        label: status,
                        type: 'SUCCESS'
                    }
                case 'INACTIVE':
                    return {
                        label: status,
                        type: 'WARNING'
                    }
                default:
                    return {
                        label: status ?? 'Pending',
                        type: 'MUTED'
                    }
            }
        },
        calculateSubscriptionStatus(subscription) {
            let statusConfig = {
                icon: '',
                colorClass: '',
                statusType: '',
                statusLabel: ''
            }

            if (subscription) {
                switch (subscription.status) {
                    case 'SUBSCRIPTION_INQUIRY_CONFIRMATION_PENDING':
                        statusConfig = {
                            icon: 'fa-question-circle',
                            statusLabel: this.$t('cdb.subscription.status.confirmationPending'),
                            statusType: 'MUTED',
                            colorClass: 'text-muted'
                        }
                        if (subscription.ssn_requested == true && subscription.user_has_ssn == false) {
                            statusConfig = {
                                icon: 'fa-exclamation-circle',
                                statusLabel: this.$t('cdb.subscription.status.ssnNeeded'),
                                statusType: 'DANGER',
                                colorClass: 'text-danger'
                            }
                        }
                        break;
                    case 'SUBSCRIPTION_INQUIRY_ACCEPTED':
                        statusConfig = {
                            icon: 'fa-check-circle',
                            statusLabel: this.$t('cdb.subscription.status.inquiryAccepted'),
                            statusType: 'MUTED',
                            colorClass: 'text-muted'
                        }
                        break;
                    case 'SUBSCRIPTION_HANDOVER_AGREED':
                        statusConfig = {
                            icon: 'fa-truck',
                            statusLabel: this.$t('cdb.subscription.status.handoverConfirmed'),
                            statusType: 'MUTED',
                            colorClass: 'text-muted'
                        }
                        break;
                    case 'SUBSCRIPTION_ACTIVE':
                        statusConfig = {
                            icon: 'fa-check-circle',
                            statusLabel: this.$t('cdb.subscription.status.active'),
                            statusType: 'SUCCESS',
                            colorClass: 'text-success'
                        }
                        break;
                    case 'SUBSCRIPTION_CUSTOMER_CANCELLATION':
                        statusConfig = {
                            icon: 'fa-minus-circle',
                            statusLabel: this.$t('cdb.subscription.status.customerCancellation'),
                            statusType: 'SUCCESS',
                            colorClass: 'text-success'
                        }
                        break;
                    case 'SUBSCRIPTION_INQUIRY_REJECTED':
                        statusConfig = {
                            icon: 'fa-minus-circle',
                            statusLabel: this.$t('cdb.subscription.status.inquiryRejected'),
                            statusType: 'DANGER',
                            colorClass: 'text-danger'
                        }
                        break;
                    case 'SUBSCRIPTION_FINISHED':
                        statusConfig = {
                            icon: 'fa-circle',
                            statusLabel: this.$t('cdb.subscription.status.finished'),
                            statusType: 'DANGER',
                            colorClass: 'text-danger'
                        }
                        break;
                    default:
                        statusConfig = {
                            icon: 'fa-minus-circle',
                            statusLabel: 'In checkout',
                            statusType: 'MUTED',
                            colorClass: 'text-muted'
                        }
                        break;
                }
            }

            return statusConfig
        },
    }
}
</script>
